<div class="navigation">
    <ul>
        <li><a [routerLink]="['home']">AUSTIN SIMPSON</a></li>
        <li><a [routerLink]="['programming']">PROGRAMMING</a></li>
        <li><a [routerLink]="['math']">MATH</a></li>
        <li><a [routerLink]="['articles']">ARTICLES</a></li>
        <li><a [routerLink]="['contact']">CONTACT</a></li>
    </ul>
</div>